import React from "react";
import settings from "../../configs/appSettings";
import PropTypes from "prop-types";

const ImageCheckbox = ({isSelected, isDisabled, ...rest}) => {
    const svg = `checkbox-${isSelected ? "selected" : "unselected"}${isDisabled ? "-grey" : ""}.svg`;

    return (
        <img src={`${settings.cdnUrl}/icons/${svg}`} {...rest} />
    );
};

ImageCheckbox.propTypes = {
    isSelected: PropTypes.bool,
    isDisabled: PropTypes.bool
};

export default ImageCheckbox;
